import React, { useState } from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
import { useFreecodeContextData } from 'hooks/useContext';
import ConfirmModal from 'components/Modals/confirmModal';
import { ApiMethodRow, ApiMethodItem } from './styles';
import { RoundIconButton } from 'components/Button/IconButton';
import { ObjectException } from 'global/errors';
import { Label } from '../styles';

const { FreecodeCreatorService } = services;

export default function ApiListItemDisplay({ index, apiMethod, apiType, onClickEdit, disabled }) {
  const { testImpl, setTestImpl } = useFreecodeContextData();

  const [viewDeleteModal, setViewDeletemodal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const deleteThisMethod = () => {
    if (deleting) return toast.error('Already deleting');
    setDeleting(true);

    const doConfirm = async () => {
      try {
        let response;
        let apiUpdate = { ...testImpl.api };
        apiUpdate[apiType].splice(index, 1);

        if (apiType === 'solution') {
          response = await FreecodeCreatorService.updateApiSolution(testImpl.test, testImpl._id, apiUpdate);
        } else if (apiType === 'challenge') {
          response = await FreecodeCreatorService.updateApiImplementation(testImpl.test, testImpl._id, apiUpdate);
        }
        if (response.error) throw new ObjectException(response.error?.message || 'delete failed', 'response error');
        if (!response?.api) throw new ObjectException('Response missing new api data', 'response error');

        setTestImpl((oldTestImpl) => ({
          ...oldTestImpl,
          api: response.api,
          generated: { ...response.generated, peekResponse: oldTestImpl.generated.peekResponse },
        }));
        toast.success('Method deleted');
        setViewDeletemodal(false);
      } catch (e) {
        toast.error(typeof e === 'string' ? e : e?.message || 'Could not reset');
      } finally {
        setDeleting(false);
      }
    };
    doConfirm();
  };

  return (
    <ApiMethodRow>
      <ApiMethodItem>
        <Label>{apiMethod.header ?? apiMethod.name}</Label>
      </ApiMethodItem>
      <ApiMethodItem push>
        <RoundIconButton icon="fa-regular fa-file-code" isAPIButton onClick={onClickEdit} disabled={disabled} />
      </ApiMethodItem>
      <ApiMethodItem>
        <RoundIconButton
          icon="fa-solid fa-trash"
          isAPIButton
          onClick={() => setViewDeletemodal(true)}
          disabled={disabled}
        />
      </ApiMethodItem>
      {viewDeleteModal && (
        <ConfirmModal
          isFreecodeModal
          title={`Delete "${apiMethod.header ?? apiMethod.name}"`}
          text="Are you sure you want to delete this API method?"
          onCancel={() => !deleting && setViewDeletemodal(false)}
          onConfirm={deleteThisMethod}
          loading={deleting}
        />
      )}
    </ApiMethodRow>
  );
}
